import { Lock, LockOutlined, Password, PersonOutlined, SecurityOutlined, VerifiedUserOutlined, VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material'
import { Box, Button, FormControl, IconButton, InputAdornment, InputLabel, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik';
import React, { useState } from 'react'
import * as Yup from "yup";
import { ApiGetCartList, ApiUsersLogin } from '../../Core/Apicall';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setActiveCartStep, setCartList, setIsNeedtoShowConnectwithRazor, setToken, setUserDetails } from '../../Redux/Reducers/globalSlice';
import { Link, useNavigate } from 'react-router-dom';



function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Please enter a valid email address")
            .required("Email is required"),

        password: Yup.string()
            .required("Password is required")
            .min(8, "Password must be at least 8 characters"),
    });


    const GetCartlist = async () => {
        try {
            const res = await ApiGetCartList()
            if (res?.status) {
                dispatch(setCartList(res?.data))
                dispatch(setActiveCartStep(0))
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    email: values.email?.toLocaleLowerCase()?.trim(),
                    password: values.password?.trim()
                }
                const res = await ApiUsersLogin(data)
                if (res?.accessToken) {
                    dispatch(setToken(res?.accessToken))
                    dispatch(setUserDetails(res?.user))
                    if (res?.user?.role === 'client') {
                        dispatch(setIsNeedtoShowConnectwithRazor(!res?.user?.razorpayConnected))
                    }
                    else if (res?.user?.role === 'subclient') {
                        GetCartlist()
                    }
                    navigate(`/${res?.user?.role}/dashboard`)
                }
            } catch (error: any) {
                console.log("Error", error)
                toast.error(error?.message || "Something went wrong")
            }
        },
    });



    return (
        <Box className='p-lg-5 p-2 d-flex align-items-center justify-content-center overflow-auto h-100 w-100'>
            <Box className='p-lg-5 p-3 d-flex flex-column h-100  w-100 border-10 overflow-auto' sx={{ maxHeight: '700px', maxWidth: "700px", border: { xs: 'none', md: '1px solid #ccc' } }}>
                <Typography variant='h5' className='text-center fw-bold'>Sign In</Typography>
                <Typography className='text-center text-grey mb-3'>Enter your credentilas to continue</Typography>
                <Box
                    sx={{ flex: 1 }}
                    component="form"
                    onSubmit={formik.handleSubmit}
                    className="mt-3 form-text-field"
                >
                    <Typography className="fw-bold mb-2">
                        Email Address
                    </Typography>

                    <FormControl fullWidth>
                        <TextField
                            fullWidth
                            name="email"
                            placeholder="Enter your email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonOutlined />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                    </FormControl>

                    <Box className="my-4">
                        <Typography className="fw-bold mb-2">
                            Password
                        </Typography>

                        <FormControl fullWidth>
                            <TextField
                                fullWidth
                                name="password"
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.password &&
                                    Boolean(formik.errors.password)
                                }
                                helperText={
                                    formik.touched.password &&
                                    formik.errors.password
                                }
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LockOutlined />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                            />
                        </FormControl>
                        <Box className='d-flex justify-content-end mt-2'>
                        <Link to={'/forgot-password'} className='text-main text-end' style={{fontSize:'12px'}}>Forgot Passowrd</Link>
                        </Box>
                    </Box>
                    <Button
                        type="submit"
                        fullWidth
                        className="btn-main border-10"
                        sx={{ py: 1.5 }}
                    >
                        Sign In
                    </Button>
                    
                </Box>
                <Box className='d-flex align-items-center gap-2 justify-content-center'>
                    <Box className='d-flex  align-items-center gap-1'>
                        <VerifiedUserOutlined fontSize='small' className='text-main' />
                        <Typography variant='body2' className='text-grey'>Secure login</Typography>
                    </Box>
                    <Typography>|</Typography>
                    <Typography variant='body2' className='text-grey'> Your data is always protected</Typography>
                </Box>
                <Typography variant='body2' className='text-grey text-center mt-2'>&copy; {new Date().getFullYear()} <span className='text-main'>Wholesale pro.</span> All rights reserved</Typography>
            </Box>
        </Box>
    )
}

export default Login
